import { useSelector } from 'react-redux';

import {
    platform,
    PowerFunnelEvents,
    PowerFunnelGatedFeatures,
    PowerFunnelSurfaces,
    PowerFunnelUserStatuses,
    SubscriptionTerms,
    SubscriptionTypes,
} from '../Analytics/constants';
import { trackEvent } from '../Analytics/TrackedClick';

export const usePowerFunnelTracking = ({
    referringSurface,
    gatedFeature = null,
    prismicTitle,
    sourceEventId,
} = {}) => {
    const user = useSelector(({ auth }) => auth?.user);
    const userSubscriptionStatus = user?.isPowered ? SubscriptionTypes.POWER : SubscriptionTypes.FREE;
    const resolvedReferringSurface = referringSurface || PowerFunnelSurfaces.UNKNOWN;
    const resolvedGatedFeature = gatedFeature || PowerFunnelGatedFeatures.WEB_DIRECT_TO_SUBSCRIPTION;

    if (process.env.NODE_ENV !== 'production' && resolvedReferringSurface === PowerFunnelSurfaces.UNKNOWN) {
        // eslint-disable-next-line no-console
        console.error('usePowerFunnelTracking: referringSurface missing — emitting web_unknown');
    }

    const fire = (eventName, extraProps = {}) => {
        trackEvent(eventName, {
            platform,
            userSubscriptionStatus,
            referringSurface: resolvedReferringSurface,
            gatedFeature: resolvedGatedFeature,
            ...(prismicTitle && { prismicTitle }),
            ...(sourceEventId && { sourceEventId }),
            ...extraProps,
        });
    };

    const trackPowerPaywallViewed = () => fire(PowerFunnelEvents.POWER_PAYWALL_VIEWED);

    const trackPowerCheckoutStarted = ({
        billingCycle,
        priceLocal,
        currency,
    } = {}) => fire(PowerFunnelEvents.POWER_CHECKOUT_STARTED, {
        planSelected: SubscriptionTypes.POWER,
        billingCycle,
        priceLocal,
        currency,
    });

    const trackPowerPurchaseSucceeded = ({
        billingCycle,
        priceLocal,
        currency,
    } = {}) => fire(PowerFunnelEvents.POWER_PURCHASE_SUCCEEDED, {
        // Override the render-time status: payment succeeds before fetchAuthenticatedUser
        // refreshes Redux, so user.isPowered is still false when this fires.
        // Annual → 'power'; monthly → 'monthly' (Segment uses all three tiers).
        userSubscriptionStatus: billingCycle === SubscriptionTerms.ANNUAL
            ? SubscriptionTypes.POWER
            : PowerFunnelUserStatuses.MONTHLY,
        billingCycle,
        priceLocal,
        currency,
    });

    return {
        trackPowerPaywallViewed,
        trackPowerCheckoutStarted,
        trackPowerPurchaseSucceeded,
    };
};
